import { render, staticRenderFns } from "./DamagedHeader.vue?vue&type=template&id=1b45a886&scoped=true&"
import script from "./DamagedHeader.vue?vue&type=script&lang=js&"
export * from "./DamagedHeader.vue?vue&type=script&lang=js&"
import style0 from "./DamagedHeader.vue?vue&type=style&index=0&id=1b45a886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45a886",
  null
  
)

export default component.exports